// The maps layout's routes. All three share ONE <Route> in App.tsx (array path)
// so PlacesApp and the map never remount when the path changes.
export const SEARCH_PATH = '/search'
export const SUGGEST_PATH = '/suggest'
